// Module
var code = "<vis-network ng-if=\"vm.graphLoaded\" data=\"vm.graphData\" options=\"vm.graphOptions\" events=\"vm.graphEvents\" class=\"mx-control--avoid-hiding\"></vis-network>\r\n";
// Exports
export default code;